module.exports = __webpack_public_path__ + "static/media/temperature.036ada48.png";